var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"addCustomerCondition"},[_vm._m(0),_c('div',{staticStyle:{"margin-top":"10px"}},[_c('timeGroupSelect',{on:{"queryValue":_vm.queryCustomer}})],1),_c('div',{attrs:{"id":"addCustomerChart"}})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_c('i',{staticClass:"el-icon-s-marketing",staticStyle:{"color":"#006eff"}}),_vm._v(" 新增客户情况 ")])
}]

export { render, staticRenderFns }